const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the Explore top bar directive which handles the categories for content and people search window
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Categories} Categories injected to gain access to the Categories resource
 */
app.directive('exploreTopbar', ['Application', 'Authorization', 'Categories', 'i18n', '$translate', function(Application, Authorization, Categories, i18n, $translate) {
    return {
      restrict: 'E',
      scope: {
        contentCategory: '=',
        active: '=',
        peopleSearch: '&',
        peopleView: '=',
        clearSearch: '=',
        searchQueries: '=',
        allowOrder: '='
      },
      template: require('../../templates/directives/explore-topbar.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.user = Authorization.getAuthToken().user;
          self.isAdmin = self.user && self.user.role && self.user.role === 'admin';
          self.isExternal = self.user && self.user.role && self.user.role === 'external';
          self.routeParameters = Application.navigation.getRouteParameters();
          self.translations = [];
          self.mainCategory = null;
          self.levelOne = [];
          self.choice = {};
          self.options = {};
          self.directory = {};
          self.userRestrictions = {'last_login': '$exists,true'};
          self.usersearch = false;
          self.usersearchCopy = "Search";
          self.flags = Application.features.flags();
          self.changePlaceholder = function(){

            self.usersearchCopy = self.translations['explore.search_by'];
          };
          self.resetScroll = function(){
            var elm = document.querySelector('.explore__smartcontainer');
            if (elm) {
              elm.scrollTo(0, 0);
            }
          };

          var sortCategories = function(categories) {
            for (var i = 0; i < categories.length; i++) {
              var cat = categories[i];
              var level = cat.level;

              var addToDirectory = function() {
                if (!self.directory[cat._id]) {
                  self.directory[cat._id] = {
                    item: null,
                    children: []
                  };
                }
                if (cat.parent && !self.directory[cat.parent]) {
                  self.directory[cat.parent] = {
                    item: null,
                    children: []
                  };
                  self.directory[cat.parent].children.push(cat);
                } else if (cat.parent) {
                  self.directory[cat.parent].children.push(cat);
                }
                self.directory[cat._id].item = cat;
              };

              if (cat.category) {
                // Add to array based on category level (10 is reserved for main category i.e. 'News')
                switch (parseInt(level)) {
                  case 1:
                    self.levelOne.push(cat);
                    addToDirectory();
                    break;
                  case 2:
                    addToDirectory();
                    break;
                  case 3:
                    addToDirectory();
                    break;
                  case 10:
                    self.mainCategory = cat;
                    addToDirectory();
                    break;
                  default:
                    break;
                }
              }
            }
            self.sortParam(self.levelOne, 'createdAt', 1);

            if (self.mainCategory) {
              self.levelOne.unshift(self.mainCategory);
              self.chooseCategory(self.levelOne[0]);
            } else if (self.levelOne.length) {
              self.chooseCategory(self.levelOne[0]);
            } else if (self.isExternal) {
              self.chooseCategory('');
            } else {
              $scope.contentCategory = '';
            }
          };

          self.sortParam = function(items, parameter, order) {
            order = order === undefined ? 1 : order;

            items.sort(function(a, b) {
              if (a[parameter] < b[parameter]) {
                return (-1 * order);
              }
              if (a[parameter] > b[parameter]) {
                return (1 * order);
              }
              return 0;
            });

            return items;
          };

          self.checkMain = function() {
            if (!self.choice[1]) {
              return false;
            }
            if (self.mainCategory && self.choice[1]._id && self.choice[1]._id.toString() === self.mainCategory._id.toString()) {
              return false;
            }

            return true;
          };

          self.checkDropOne = function() {
            if (!self.choice[1] || self.choice[2]) {
              return false;
            }
            if (typeof self.options[2] !== 'object' || !self.options[2].length) {
              return false;
            }
            return true;
          };

          self.checkDropTwo = function() {
            if (!self.choice[1] || !self.choice[2] || self.choice[3]) {
              return false;
            }
            if (typeof self.options[3] !== 'object' || !self.options[3].length) {
              return false;
            }
            return true;
          };

          self.toggleDrop = function(cat) {
            if (cat.level === 2) {
              clearSettings(1);
              self.dropOne = true;
            }
            if (cat.level === 3) {
              clearSettings(2);
              self.dropTwo = true;
            }
          };

          var clearSettings = function(level) {
            var i = parseInt(level) || 0;
            i++;

            while (i < 4) {
              self.choice[i] = null;
              self.options[i + 1] = [];
              i++;
            }
            self.dropOne = false;
            self.dropTwo = false;
          };

          var innerCategory;
          self.chooseCategory = function(category) {
            if (!category && self.isExternal) {
              $scope.contentCategory = 'empty_external';
              innerCategory = category;
              clearSettings(level);
              self.resetScroll();
              return;
            }
            var level = parseInt(category.level) === 10 ? 1 : parseInt(category.level);
            $scope.contentCategory = category;
            innerCategory = category;
            self.choice[level] = category;
            self.options[level + 1] = self.directory[category._id].children || [];
            self.sortParam(self.options[level + 1], 'name');
            clearSettings(level);
            if (category.level !== 10 || self.checkedReset) {
              Application.categories.set(category._id);
            }
            self.resetScroll();
          };

          self.resetState = function(choice) {
            // set true returned category state
            if (!choice) {
              self.resetState(self.mainCategory._id.toString())
              return;
            }
            var item = self.directory[choice];
            if (!item || !item.item) {
              self.resetState(self.mainCategory._id.toString())
              return;
            }
            item = item.item;
            var count;
            var allSelections = {};
            var highest;
            allSelections[item.level] = item;
            highest = item.level;
            if (highest > 1) {
              count = 0;
              while (item.parent && count < 4) {
                count++;
                item = self.directory[item.parent];
                if (!item || !item.item) {
                  break;
                }
                item = item.item;
                allSelections[item.level] = item;
              }
            }

            var cascade = function() {
              if (!allSelections[1]) {
                return;
              }
              for (var i = 0; i < self.levelOne.length; i++) {
                if (self.levelOne[i]._id.toString() === allSelections[1]._id.toString()) {
                  self.chooseCategory(self.levelOne[i]);
                  break;
                }
              }
              if (!allSelections[2] || !self.options[2]) {
                return;
              }
              for (var i = 0; i < self.options[2].length; i++) {
                if (self.options[2][i]._id.toString() === allSelections[2]._id.toString()) {
                  self.chooseCategory(self.options[2][i]);
                  break;
                }
              }
              if (!allSelections[3] || !self.options[3]) {
                return;
              }
              for (var i = 0; i < self.options[3].length; i++) {
                if (self.options[3][i]._id.toString() === allSelections[3]._id.toString()) {
                  self.chooseCategory(self.options[3][i]);
                  break;
                }
              }
            };
            cascade();

          };

          self.orderClick = function() {
            $scope.active = 'order';
          };

          self.initialize = function() {
            var query = {category: true};
            if (self.isExternal) {
              query.show_external = true;
            }
            Categories.find(query).$promise.then(function(cats) {
              cats = i18n.localize_categories(cats);
              sortCategories(cats);
              var reset = (self.routeParameters && self.routeParameters.category) || Application.categories.get();
              if (reset) {
                self.checkedReset = true;
                self.resetState(reset);
              }
            });
          };

          $scope.$watch('contentCategory', function(newVal, oldVal) {
            if (!$scope.contentCategory || !innerCategory) {
              return;
            }
            if ($scope.contentCategory._id !== innerCategory._id) {
              self.chooseCategory($scope.contentCategory);
            }
          });

          self.newUserFilter = function(query) {
            $scope.peopleSearch({query: query});
          };

          $translate(['explore.search_by']).then(function (translations) {
            self.translations = translations;
            self.initialize();
          });


        }],
      controllerAs: 'exploretop'
    };
  }]);
